module.exports = __webpack_public_path__ + "static/media/user.c3631c65.png";